import { getSiteLanguage } from './commons';
import {
	AGENDA_TYPES,
	CROSS_TYPES,
	LANGUAGES_LIST,
	LIST_VIEW_TYPES,
	SAVE_SETTINGS_VIEW_PLUGIN_NAMES
} from './constants';

export const DEFAULT_VALUES = {
	lang: getSiteLanguage(),
	showTZone: false,
	firstDay: '',
	timeFormat: '',
	headerDateAlign: '0',
	popType: '1',
	weekNumbers: '1',
	showTimeMonthly: false,
	showTitleInMobile: false,
	showSkeletonInMobile: false,
	categoryShow: false,
	categorySectionPosition: '1',
	defaultView: '0',
	defaultViewMobile: '0',
	fixedWeekCount: false,
	mobileShowDates: true,
	showHoursW: '0',
	minTime: '16',
	maxTime: '43',
	agendaStyle: '1',
	headerText: '',
	agendaEventLimit: 20,
	hideAgendaHeader: true,
	hideWeeklyDailyHeader: true,
	hideMonthlyHeader: true,
	hideListHeader: true,
	agendaShownOnlyUpcomings: true,
	agendaShowAdditionalDate: true,
	agendaReverse: '0',
	showViews: false,
	hideCardHeader: true,
	hideMapHeader: true,
	hideTimelineHeader: true,
	gridShownOnlyUpcomings: false,
	gridReverse: '0',
	gridCardsInRow: 3,
	gridCardsSpace: 16,
	gridEventLimit: 6,
	mapStylePicker: '',
	addCalendarButton: true,
	shareEvents: true,
	showSearch: true,
	printButton: false,
	weatherForecastShow: false,
	temperatureUnit: '0',
	addEventButton: false,
	hide0: true,
	hide1: true,
	hide2: true,
	hide3: true,
	hide4: true,
	hide5: true,
	hide6: true,
	hideMonth: true,
	hideAgendaWeek: false,
	hideAgendaDay: false,
	hideList: false,
	hideUpcomingEvents: true,
	hideGrid: false,
	hideMap: false,
	hideToday: true,
	hidePrev: true,
	hideNext: true,
	eventLimit: 7,
	aspectRatio: 1,
	calendarBorderSize: 20,
	calendarRadius: 0,
	buttonBorderSize: 1,
	lightMode: true,
	defaultDate: '5',
	autotranslation: false,
	showMobileNoEventsText: true,
	showShowMoreButton: true,
	listViewType: '2',
	timelineAlignmentType: '0',
	timelineVerticalAlignmentType: '0',
	timelineHorizontalAlignmentType: '0',
	timelineDateType: '0',
	timelineEventLimit: 20,
	timelineReverse: false,
	timelineShownOnlyUpcomings: false,
	mapShownOnlyUpcomings: false,
	hideTimelineHeader: true,
	crossCardSpasce: 16,
	crossImageOpacity: 100,
	crossStyle: 1,
	crossAlign: 0,
	hideCrossHeader: true,
	hideCustomViewHeader: true,
	crossViewColumnProportions: 50,
	hideYearHeader: true,
	timeZoneParams: 15,
	agendaStyle: 'modern',
	agendaMonthSeparator: true,
	agendaTooltipPopup: false
};

const eventLayoutTypes = ['tooltip', 'popup', ''];

export const processDefaultValues = currentData => {
	const processData = { ...currentData.booleans, ...currentData.numbers };
	const {
		defaultView,
		popType,
		agendaStyle,
		crossStyle,
		listViewType,
		lang,
		hideMap,
		hideGrid,
		hideCross,
		hideYear,
		hideNext,
		hidePrev
	} = processData;

	return {
		...DEFAULT_VALUES,
		...processData,
		defaultView: SAVE_SETTINGS_VIEW_PLUGIN_NAMES[defaultView],
		popType: eventLayoutTypes[popType],
		agendaStyle: AGENDA_TYPES[agendaStyle],
		crossStyle: CROSS_TYPES[crossStyle],
		listViewType: LIST_VIEW_TYPES[listViewType],
		lang: LANGUAGES_LIST[lang],
		hideCross: !hideCross,
		hideGrid: !hideGrid,
		hideMap: !hideMap,
		hideYear: !hideYear,
		hideNext: !hideNext,
		hidePrev: !hidePrev
	};
};
